function _pipe(f, g) {
  return function () {
    return g.call(this, f.apply(this, arguments));
  };
}
module.exports = _pipe;


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/ramda/src/internal/_pipe.js
// module id = 4092
// module chunks = 168707334958949